import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  DialogActions,
  Button,
  makeStyles,
} from "@fluentui/react-components";
import { Chapter } from "../models/Chapter";
import { useNavigate } from "react-router-dom";
import { useDeleteChapter } from "../hooks/useChapter";
import { ClientRoutes } from "../models/ClientRoutes";
import { useTranslation } from "react-i18next";
import { SkanskaColorTokens } from "../style/colors";

interface ChapterDeleteButtonProps {
  Chapter: Chapter;
}
const useStyles = makeStyles({
  confirmDeleteButton: {
    backgroundColor: SkanskaColorTokens.color_tertiary_red_30,
    ":hover, :focus, :active": {
      backgroundColor: SkanskaColorTokens.color_tertiary_red,
      color: SkanskaColorTokens.color_secondary_white,
    },
  },
});

export const ChapterDeleteButton = (props: ChapterDeleteButtonProps) => {
  const { mutateAsync: deleteChapter, isPending: deleteIsPending } =
    useDeleteChapter(props.Chapter.id);
  const navigate = useNavigate();

  const classes = useStyles();
  const { t } = useTranslation();

  const onConfirm = async () => {
    await deleteChapter();
    navigate(ClientRoutes.Chapters);
  };

  return (
    <Dialog modalType="alert">
      <DialogTrigger disableButtonEnhancement>
        <Button className={classes.confirmDeleteButton}>{t("delete")}</Button>
      </DialogTrigger>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("delete")}</DialogTitle>
          <DialogContent>
            {t("deleteChapterPrompt")} "{props.Chapter.title}
            "?
          </DialogContent>
          <DialogActions>
            <DialogTrigger disableButtonEnhancement>
              <Button appearance="secondary">{t("cancel")}</Button>
            </DialogTrigger>
            <Button
              disabled={deleteIsPending}
              onClick={onConfirm}
              appearance="primary"
            >
              {t("delete")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
